const { DeviceClass } = require('@kentik/ui-shared/nms/deviceMetadata');

const NmsDeviceClassLabel = {
  [DeviceClass.AccessPoint]: 'Access Point',
  [DeviceClass.Firewall]: 'Firewall',
  [DeviceClass.LoadBalancer]: 'Load Balancer',
  [DeviceClass.OpticalTransport]: 'Optical Transport',
  [DeviceClass.PDU]: 'Power Distribution Unit',
  [DeviceClass.Router]: 'Router',
  [DeviceClass.SdwanGateway]: 'SD-WAN Gateway',
  [DeviceClass.Server]: 'Server',
  [DeviceClass.StorageArray]: 'Storage Array',
  [DeviceClass.Switch]: 'Switch',
  [DeviceClass.UPS]: 'Uninterruptible Power Supply',
  [DeviceClass.WirelessController]: 'Wireless Controller'
};

const NonNmsDeviceClass = {
  Flow: 'flow',
  FlowIcmp: 'flow-icmp',
  Icmp: 'icmp'
};

const NonNmsDeviceClassLabel = {
  [NonNmsDeviceClass.Flow]: 'Flow',
  [NonNmsDeviceClass.FlowIcmp]: 'Flow + ICMP',
  [NonNmsDeviceClass.Icmp]: 'ICMP'
};

const AllDeviceClass = {
  ...NonNmsDeviceClass,
  ...DeviceClass
};

const AllDeviceClassLabel = {
  ...NmsDeviceClassLabel,
  ...NonNmsDeviceClassLabel
};

const getDeviceClassFilterOptions = () => {
  const nmsClasses = Object.values(DeviceClass).map((deviceClass) => ({
    label: NmsDeviceClassLabel[deviceClass],
    value: deviceClass
  }));

  const nonNmsClasses = Object.values(NonNmsDeviceClass).map((deviceClass) => ({
    label: NonNmsDeviceClassLabel[deviceClass],
    value: deviceClass
  }));

  return nmsClasses.concat(nonNmsClasses);
};

module.exports = {
  AllDeviceClass,
  AllDeviceClassLabel,
  NmsDeviceClassLabel,
  NonNmsDeviceClass,
  NonNmsDeviceClassLabel,
  getDeviceClassFilterOptions
};
